import { render, staticRenderFns } from "./ReviewerContactsManager.vue?vue&type=template&id=60feecea&scoped=true"
import script from "./ReviewerContactsManager.vue?vue&type=script&lang=js"
export * from "./ReviewerContactsManager.vue?vue&type=script&lang=js"
import style0 from "./ReviewerContactsManager.vue?vue&type=style&index=0&id=60feecea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60feecea",
  null
  
)

export default component.exports